module.exports = __webpack_public_path__ + "img/brand-pic1-03.d39006cf.png";